<template>
	<div class="alone_wrap">
		<div class="alone_wrap_cont">
			<div class="into" v-if="show1">
				<img class="img1" src="./imgs/new1.png" />
				<img @click="into(1)" class="img2" src="./imgs/btnInto.png" >
			</div>
			<div class="login" v-if="show2">
				<img src="./imgs/new2.png" />
        <img @click="into(2)" class="img3" src="./imgs/denglu.png" />
			</div>
      <div class="action" v-if="show3">
        <img src="./imgs/new3.png" />
        <img class="img4" src="./imgs/2.png"/>
        <div class="time_num">{{(count<10)?'0'+count:count}}</div>
				<div class="text">
					<div class="ksxz_contain" id="kaowu" style="display:block;text-align:left; color:black;">
						<div style="text-align:center;font-size:14pt;margin-top: 16px;"><b>考生须知</b></div>
							<div class="cont" style="text-align:left;font-size:12pt; ">            
								<p><b>第一条</b> 考试开始前30分钟，考生凭本人准考证和有效居民身份证（香港、澳门、台湾籍考生凭有效身份证明，下同）进入考场，完成电子签到后，按照监考人员指定的位置入座，并将准考证和有效居民身份证放置在桌面右上角。</p>
								<p><b>第二条</b> 考生进入考场时，应将准考证和有效居民身份证之外的其他物品(手机、电子设备应设置成关闭状态）存放在考场指定位置。携带准考证和有效居民身份证之外的物品（含电子、通讯、计算、存储等设备）进入考位，按违纪进行处理。</p>
								<p><b>第三条</b> 考生在完成签到后不得随意离开考场，如确有特殊情况需要暂时离开考场，必须经监考人员同意并由指定的监考人员陪同，凭本人有效居民身份证出入考场。考生在考试中途暂离考场，其离场时间计入本人的考试时间。</p>
								<p><b>第四条</b> 考场为考生统一提供演算纸笔。考试结束后，演算纸笔由监考人员统一收回，考生不得带出考场，违者按违纪进行处理。</p>
								<p><b>第五条</b> 考生入座后，在登录界面输入准考证号和居民身份证号登录考试系统，认真核对屏幕显示的本人相关信息，阅读并遵守《考生须知》及《操作说明》，等待考试开始。</p>
								<p><b>第六条</b> 考试时间以考试系统计时器为准。考试开始30分钟后，未签到的考生视为缺考，考试系统不再接受考生的登录。</p>
								<p><b>第七条</b> 进入考场后，考生应自觉遵守考场规定，维护考场秩序，尊重并自觉接受监考人员的监督和检查，保持考场安静，遇到问题应当举手示意。</p>
								<p><b>第八条</b> 考试过程中，如机器设备、网络、电力出现异常情况，考生应及时举手示意，请监考人员协调解决，不得自行处置，严禁自行关闭或重启考试机。因机器设备故障等客观原因导致答题时间出现损失，考生可以当场向监考人员提出补时要求，由监考人员根据有关规定予以处理。考试结束后，不再受理考生未当场提出的补时要求。</p>
								<p><b>第九条</b> 考试开始90分钟后，考生方可交卷离开考场。考生交卷后应当立即自行离开考场，严禁关闭考试机，不得在考场附近逗留、交谈或喧哗。</p>
								<p><b>第十条</b> 考试时间到，考试系统将自动为所有未交卷的考生统一交卷。</p>
								<p><b>第十一条</b> 考试期间，考生应按照考试系统要求进行操作，由于进行与考试无关的操作所造成的一切后果，由考生本人负责。</p>
								<p><b>第十二条</b> 考试期间违纪违规，依据《专业技术人员资格考试违纪违规行为处理规定》（人社部令第31号）进行处理。有严重和特别严重违纪违规行为的考生，将被记入会计资格考试诚信档案库，有关信息将向社会公告，并通知当事人所在单位，相关记录也将纳入全国信用共享平台。</p>
							</div>
					</div>
				</div>
      </div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				show1: true,
				show2: false,
        show3: false,
        count: '',
        timer: null,
			}
		},
		methods: {
			into(num){
        if(num == 1){
          this.show1 = false
          this.show2 = true
          this.show3 = false
        }else if(num == 2){
          this.show1 = false
          this.show2 = false
          this.show3 = true
          this.timeShow()
        }

			},
      timeShow(){
        const TIME_COUNT = 10;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.$router.push({
              path: "/switch/test/testSimulationNew",
              query: {
                id: this.$route.query.id,
                paperId:this.$route.query.paperId,
                catalogId:this.$route.query.catalogId,
                paperCode:this.$route.query.paperCode,
                total:this.$route.query.totalQuestion,
                className:this.$route.query.className,
                paperName:this.$route.query.paperName,
                paperScore:this.$route.query.totalScore,
                count:this.$route.query.totalQuestion,
                examTestType:1,
                resourceId:this.$route.query.paperId,
                classId: this.$route.query.classId,
                type:1,
                examId:this.$route.query.examId,
                finishFlag:1,
                isOutOfOrder: this.$route.query.isOutOfOrder,
                flag:false
               }
            });
          }
         }, 1000)
        }
      }
		}
	}
</script>

<style lang="scss">
	.alone_wrap {

		.alone_wrap_cont {
			width: 1024px;
			margin: 0 auto;
      text-align: center;
			.into {
				width: 1024px;
				height: 768px;
				position: relative;
				.img1 {
					display: inline-block;
					width: 100%;
					height: 100%;
				}
				.img2 {
					position: absolute;
					width: 150px;
					height: 50px;
					top: 287px;
					left: 437px;
					cursor: pointer;
				}
			}
      .login {
        position: relative;
        margin-top: 50px;
        .img3 {
          position: absolute;
          top: 259px;
          left: 541px;
          cursor: pointer;
        }
      }
      .action {
        position: relative;
        .img4 {
          position: absolute;
          top: 56px;
          right: 151px;
        }
        .time_num {
          position: absolute;
          top: 70px;
          right: 166px;
          color: #F00;
          font-size: 20px;
          font-weight: bolder;
        }
				.text {
					position: absolute;
					width: 939px;
					height: 529px;
					overflow: auto;
					background-color: #fff;
					top: 190px;
					left: 42px;
					.cont {
						p {
							margin: 16px 5px;
							line-height: 32px;
						}
					}
				}
      }
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/teachingDetail/list/mockexamination/aloneNew.vue